<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'property-create create-form'"
    v-if="getPermission('property:create') || getPermission('property:update')"
  >
    <template v-slot:header-title>
      <div class="d-flex">
        <h1 class="form-title text-truncate">
          Site Location For
          <span class="form-title-create-link orange--text" link>{{
            customerObject.display_name
          }}</span>
        </h1>
        <v-chip
          label
          v-if="barcode"
          color="chip-custom-blue"
          outlined
          class="text-white p-3 ml-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          <template>
            {{ barcode }}
          </template>
        </v-chip>
        <v-spacer></v-spacer>
        <div class="ml-3 form-title-link text-h5 form-title">
            Entity : {{ entityObject?.name }}
        </div>
      </div>
    </template>
    <template v-slot:header-action>
      <v-btn
        depressed
        v-on:click="goBack"
        :disabled="formLoading"
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        depressed
        :disabled="!formValid || formLoading"
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        v-on:click="onSubmit"
        color="cyan"
      >
        {{ getAction }} Site Location
      </v-btn>
    </template>
    <template v-slot:body>
      <v-form
        ref="propertyForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="onSubmit"
      >
        <v-row class="white-background create-property-height">
          <v-col cols="7">
            <PropertyAddress
              v-on:savePropertyAddress="updatePropertyAddress"
              v-on:updateMapMarker="updatePosition"
              :propertyData="propertyArr"
              :options="options"
              :defaultPosition="mapCenter"
              :property-customer="customerObject"
              :isDialog="true"
            ></PropertyAddress>
          </v-col>
          <v-col cols="5">
            <GmapMap ref="mapRef" :center="mapCenter" :zoom="7">
              <GmapMarker
                :position="mapCenter"
                :draggable="true"
                v-on:dragend="positionChanged"
              />
            </GmapMap>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:extra>
      <template v-if="customerDialog">
        <CustomerDialog
          :customerDialog="customerDialog"
          v-on:closeDialog="customerDialog = false"
          v-on:resetAll="customerDialog = false"
          v-on:selectCustomer="selectCustomer"
        ></CustomerDialog>
      </template>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { QUERY, PUT, CLEAR_ERROR } from "@/core/services/store/request.module";
import PropertyAddress from "@/view/pages/customer/create-or-update/Property-Address.vue";
import PropertyMixin from "@/core/plugins/property-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { mapGetters } from "vuex";
import {
    SET_ENTITY
} from "@/core/services/store/entity.module";
export default {
  mixins: [CommonMixin, PropertyMixin],
  name: "property-create",
  title: "Create Site Location",
  data() {
    return {
      customer: 0,
      customerDialog: 0,
      propertyCreated: false,
      property: 0,
      propertyArr: {},
      barcode: null,
      entityObject: {},
      customerObject: {},
      propertyAddress: {},
      billingAddress: {},
      contactDetail: {},
      contactPerson: [],
      notification: {},
      options: {},
      tabs: [
        { title: "Contact Details", icon: "mdi-phone", key: "details" },
        {
          title: "Contact Persons",
          icon: "mdi-account-multiple",
          key: "persons",
        },
        {
          title: "Site Location Address",
          icon: "mdi-home-map-marker",
          key: "property",
        },
        { title: "Company Address", icon: "mdi-credit-card", key: "billing" },
        {
          title: "Remarks",
          icon: "mdi-bell-ring",
          key: "notification",
        },
      ],
     mapCenter: { lat: 3.139003, lng: 101.686855, custom: false },
      propertyTab: null,
    };
  },
  components: {
    PropertyAddress,
    CustomerDialog,
    CreateUpdateTemplate,
  },
  watch: {
    formValid(param) {
      if (param) {
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
    property(param) {
      if (param > 0) {
        this.getPropertyDetail();
      }
    },
  },
  methods: {
    selectCustomer(customer) {
      if (customer > 0) {
        this.hasChanges = false;
        this.$router
          .replace(
            this.getDefaultRoute("property.create", {
              query: { customer },
            })
          )
          .then(() => {
            window.location.reload(true);
          });
      }
    },
    updatePosition(param) {
      if (param) {
        this.mapCenter.custom = true;
        this.mapCenter.lat = param.lat;
        this.mapCenter.lng = param.long;
      }
    },
    positionChanged(param) {
      if (param.latLng) {
        this.mapCenter.custom = false;
        this.mapCenter.lat = param.latLng.lat();
        this.mapCenter.lng = param.latLng.lng();
      }
    },
    updatePropertyAddress(param) {
      this.propertyAddress = param;
    },
    getOptions() {
      const _this = this;
      let data = {
        customer: _this.customer,
        entity: _this.$route?.query?.entity,
      };
      _this.$store
        .dispatch(QUERY, { url: "property/options", data })
        .then(({ data }) => {
          _this.customerObject = data.customer;
          _this.entityObject = data.entity_relation;
          _this.$store.commit(SET_ENTITY,data?.entity_relation);
          _this.options = data.options;
          if (_this.property == 0) {
            _this.barcode = data.barcode;
          }

          if (data.options) {
            _this.options.active_zones = data.active_zones;
            //console.log(_this.options);
          }
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    onSubmit() {
      const _this = this;

        if (!_this.reEntityId) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }
      if (!_this.$refs.propertyForm.validate()) {
        return false;
      }

      if (_this.propertyAddress.is_tenant) {
        if (!_this.propertyAddress.contact_person) {
          ErrorEventBus.$emit("update:error", "Please enter tenant details.");
          return false;
        }
      } else {
        if (!_this.propertyAddress.contact_person) {
          ErrorEventBus.$emit("update:error", "Please select contact person.");
          return false;
        }
      }

      const address = [];
      if (_this.lodash.isEmpty(_this.propertyAddress) === false) {
        address.push(_this.propertyAddress);
      }
      if (this.getAction == "Update") {
        _this.propertyAddress.doUpdate = 1;
      }
      _this.formLoading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});

      if (_this.lodash.isEmpty(address) === false) {
        _this.$store
          .dispatch(PUT, {
            url: "address/" + _this.customer,
            data: { address: address },
          })
          .then(() => {
            _this.propertyCreated = true;
            _this.$nextTick(() => {
              _this.$router.push(
                _this.getDefaultRoute("property", {
                  query: { status: "active" },
                })
              );
            });
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.formLoading = false;
          });
      }
    },
    getPropertyDetail() {
      const _this = this;
      _this
        .getProperty()
        .then((response) => {
          _this.propertyArr = response;
          _this.entityObject = this.propertyArr?.entity_relation;
          _this.$store.commit(SET_ENTITY,this.propertyArr?.entity_relation);
          _this.barcode = _this.propertyArr.barcode;
          /*     console.log(_this.propertyArr) */
          _this.customer = response.customer ? response.customer.id : 0;
          _this.mapCenter = {
            lat: parseFloat(response.latitude),
            lng: parseFloat(response.longitude),
            custom: true,
          };
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Site Location", route: "property" },
            { title: "Update" },
            // { title: response.barcode },
          ]);
        })
        .catch((error) => {
          _this.logError(error);
          _this.$router.go(-1);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    const _this = this;
    _this.getOptions();
    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Site Location", route: "property" },
      { title: "Create" },
    ]);
  },
  created() {
    const _this = this;
    _this.property = _this.lodash.toSafeInteger(_this.$route.params.id);
    _this.customer = _this.lodash.toSafeInteger(_this.$route.query.customer);
    if (_this.customer <= 0) {
      _this.$router.go(-1);
    }
  },
  computed: {
    ...mapGetters(["cc_persons", "reCustomerId", "vCustomerId","reEntityId"]),
    getAction() {
      if (this.property) {
        return "Update";
      }
      return "Save";
    },
    getPropertyTitle() {
      const _this = this;
      if (_this.propertyArr && _this.propertyArr.barcode) {
        return " • " + _this.propertyArr.barcode;
      }
      return "";
    },
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.propertyCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
